<p-dataTable
  #outerDt
  tableStyleClass="bfx-find-filter-outer-table"
  [value]="data"
  expandableRows="true"
  [rowTrackBy]="identifyFilterData"
  [emptyMessage]=""
  *ngIf="async_data | async"
>
  <p-column field="label">
    <ng-template pTemplate="header"></ng-template>
    <ng-template pTemplate="body" let-data="rowData" let-i="rowIndex">
      <div
        role="button"
        class="title"
        [ngClass]="{'expanded': outerDt.isRowExpanded(data), 'col-label-expander': true}"
        (click)="toggleRow(outerDt,data,$event, i)"
      >
        <span
          #headerToggleElement
          role="button"
          class="col-icon"
          tabindex="0"
          style="outline: 0"
          (click)="toggleRow(outerDt,data,$event, i)"
          (keydown.enter)="toggleRow(outerDt,data,$event, i)"
          (keydown.tab)="onTabHeading($event,outerDt,data,i,headerToggleElement, outerDt.isRowExpanded(data))"
          ><i
            class="icon"
            [ngClass]="{'icon-ion_chevron_down': !outerDt.isRowExpanded(data), 'icon-ion_chevron_up': outerDt.isRowExpanded(data)}"
          ></i
        ></span>
        <span class="text">{{data.label}}</span>
      </div>
    </ng-template>
  </p-column>

  <ng-template let-outerRowIndex="rowIndex" pTemplate="rowexpansion">
    <p-dataTable
      #dt
      tableStyleClass="bfx-find-filter-table"
      [immutable]="false"
      [value]="filterContents(outerRowIndex, dt)"
      scrollable="true"
      scrollHeight="490px"
      [emptyMessage]="emptyMessage"
      [editable]="true"
      [rowStyleClass]="rowStyleClass"
      (onEditInit)="onEditInit($event, outerRowIndex)"
      [patchCloseCellEvent]="getCloseCellEventData(dt)"
      (onCloseCellEvent)="onCloseCellEvent(outerRowIndex)"
      (onRowClick)="proxyRowClick($event)"
    >
      <p-column
        field="fieldTitle"
        header="Attribute"
        [editable]="false"
        styleClass="bfx-find-filter-table-cell--attribute"
      >
        <ng-template let-col let-data="rowData" let-i="rowIndex" pTemplate="body">
          <div
            #attributeDiv
            [ngClass]="{'find__dt_first_cell': (i == 0), 'find__attribute_text': true, 'find__attribute_text_between': betweenOperators[data.operator]}"
            class="find__attribute_text"
            (focus)="tabProxyToHeading($event, data, i)"
            [title]="getAttributeTooltip(attributeDiv, data, col)"
          >
            {{data[col.field]}}
          </div>
        </ng-template>
      </p-column>
      <p-column
        field="operator"
        header="Operator"
        [editable]="true"
        styleClass="bfx-find-filter-table-cell--operator"
      >
        <ng-template let-col let-data="rowData" pTemplate="body">
          <div
            [ngClass]="{ 'editable' : true, 'find__operator_text': true, 'find__operator_text_between': betweenOperators[data.operator]}"
          >
            <span *ngIf="data && data.operatorData"> {{data.operatorData.label}} </span>
            <!-- <div class="ui-clickable ui-button-icon-only icon icon-ion_chevron_down"></div> -->
          </div>
        </ng-template>
        <ng-template let-editableIndex="rowIndex" let-col let-data="rowData" pTemplate="editor">
          <bfx-autoComplete
            #selOperator
            size="sm"
            dropdownMenuClass="bfx_find_search_operator"
            (completeMethod)="searchOperator($event, data)"
            (onDropdownClick)="showOperatorOptions($event, data)"
            (ngModelChange)="onOperatorChanged($event, data)"
            (onFocusEditable)="focusEditableOperator(selOperator, data)"
            [(ngModel)]="data.input.operator"
            [autoHighlight]="true"
            [autoHighlightIndex]="operatorAutoHighlightIndex"
            [delay]="10"
            [dropdown]="true"
            [forceSelection]="false"
            [inputStyle]="{'width':'75px','text-align':'center', 'margin-right': '1px'}"
            [maxlength]="30"
            [minLength]="0"
            [skipShowTargetInvisible]="true"
            [skipSorting]="true"
            [suggestions]="operatorSuggestions"
            [tabindex]="0"
            [proxyTab]="data.proxyTabSelector || proxyOnTabSelector(data, outerDt, outerRowIndex, dt, editableIndex, col, selOperator)"
            dropdownMode="current"
            appendTo="body"
            dataKey="value"
            field="label"
            state="4"
            checkDirtyBlur="true"
          >
            <ng-template let-value pTemplate="item">
              <div *ngIf="value.value != null">{{value.label}}</div>
              <div *ngIf="value.value == null">&nbsp;</div>
            </ng-template>
          </bfx-autoComplete>
        </ng-template>
      </p-column>
      <p-column
        field="value"
        header="Value"
        [editable]="true"
        styleClass="bfx-find-filter-table-cell--value"
      >
        <ng-template let-col let-data="rowData" pTemplate="body">
          <div
            *ngIf="columnFilterTypes[data.fieldName]=='STRING'"
            title="{{getText(data)}}"
            class="find__value_text"
          >
            {{getText(data)}}
          </div>

          <div *ngIf="objectColumns[data.fieldName]" class="find__value_multi_select_text">
            <ng-container *ngIf="!objectColumns[data.fieldName]">{{getText(data)}}</ng-container>
            <div
              *ngIf="objectColumns[data.fieldName]"
              class="find__value_multi_select_text--label"
              title="{{getText(data)}}"
            >
              {{getText(data)}}
            </div>
            <bfx-icon-button
              size="xs"
              class="ui-button-icon-only"
              *ngIf="objectColumns[data.fieldName]"
              iconClass="icon-ion_chevron_down"
              class="find__value_multi_select_text--button ui-clickable"
            ></bfx-icon-button>
          </div>

          <div
            *ngIf="(columnFilterTypes[data.fieldName]=='NUMBER' || columnFilterTypes[data.fieldName]=='INT' || columnFilterTypes[data.fieldName]=='PERCENTAGE' || columnFilterTypes[data.fieldName]=='RATE') && !betweenOperators[data.operator]"
            class="ui-float-label interface-control__amount-spinner__container"
          >
            <div
              class="interface-control__amount-spinner__container-inner hideValidationBar"
              fxFlex
              fxLayout="row"
            >
              <input class="spinner-input" fxFlex fxFlexAlign="center" value="{{getText(data)}}" />

              <spinner-buttons fxFlex="none" class="spin-buttons-right" [disabled]="false">
              </spinner-buttons>
            </div>
          </div>

          <div
            *ngIf="(columnFilterTypes[data.fieldName]=='NUMBER' || columnFilterTypes[data.fieldName]=='INT' || columnFilterTypes[data.fieldName]=='PERCENTAGE' || columnFilterTypes[data.fieldName]=='RATE') && betweenOperators[data.operator]"
            class="ui-float-label interface-control__amount-spinner__container"
          >
            <div
              class="bfx-field-inputted-sm-subtle bfx-field-number spinner-input bfx-field-inputted-enabled-subtle hideValidationBar"
              fxFlex
              fxLayout="row"
            >
              <input
                class="spinner-input"
                fxFlex
                fxFlexAlign="center"
                value="{{getText(data, columnFilterTypes[data.fieldName], 'from')}}"
              />
              <span class="spinner-suffix" fxFlex="none" fxFlexAlign="center"></span>
              <spinner-buttons fxFlex="none" class="spin-buttons-right" [disabled]="false">
              </spinner-buttons>
            </div>
          </div>

          <div
            *ngIf="(columnFilterTypes[data.fieldName]=='NUMBER' || columnFilterTypes[data.fieldName]=='INT' || columnFilterTypes[data.fieldName]=='PERCENTAGE' || columnFilterTypes[data.fieldName]=='RATE') && betweenOperators[data.operator]"
            class="ui-float-label interface-control__amount-spinner__container"
          >
            <div
              class="bfx-field-inputted-sm-subtle bfx-field-number spinner-input bfx-field-inputted-enabled-subtle hideValidationBar"
              fxFlex
              fxLayout="row"
            >
              <input
                class="spinner-input"
                fxFlex
                fxFlexAlign="center"
                value="{{getText(data, columnFilterTypes[data.fieldName], 'to')}}"
              />
              <span class="spinner-suffix" fxFlex="none" fxFlexAlign="center"></span>
              <spinner-buttons fxFlex="none" class="spin-buttons-right" [disabled]="false">
              </spinner-buttons>
            </div>
          </div>

          <div
            class="find__value_date"
            *ngIf="columnFilterTypes[data.fieldName]=='DATE' && !betweenOperators[data.operator]"
          >
            <span [ngClass]="{'disabled': data.operator && !equalOperator[data.operator]}">
              {{getText(data)}}
            </span>
            <div class="find__buttons">
              <bfx-icon-button
                *ngIf="data.operator== null || equalOperator[data.operator]"
                size="xs"
                iconClass="icon-ion_chevron_down"
                (action)="dateClick('icon-ion_chevron_down')"
              ></bfx-icon-button>
              <bfx-icon-button
                size="xs"
                iconClass="icon-calendar_month"
                (action)="dateClick('icon-calendar_month')"
              ></bfx-icon-button>
            </div>
          </div>

          <div
            class="find__value_between_container"
            *ngIf="columnFilterTypes[data.fieldName]=='DATE' && betweenOperators[data.operator]"
          >
            <div class="find__value_date find__value_between_from">
              <span
                [ngClass]="{'disabled': data.operator && !equalNotEqualOperators[data.operator]}"
              >
                {{getText(data, columnFilterTypes[data.fieldName], 'from')}}
              </span>
              <div class="find__buttons">
                <bfx-icon-button
                  size="xs"
                  iconClass="icon-calendar_month"
                  (action)="dateClick('icon-calendar_month', 'from')"
                ></bfx-icon-button>
              </div>
            </div>

            <div class="find__value_date find__value_between_to">
              <span
                [ngClass]="{'disabled': data.operator && !equalNotEqualOperators[data.operator]}"
              >
                {{getText(data, columnFilterTypes[data.fieldName], 'to')}}
              </span>
              <div class="find__buttons">
                <bfx-icon-button
                  size="xs"
                  iconClass="icon-calendar_month"
                  (action)="dateClick('icon-calendar_month', 'to')"
                ></bfx-icon-button>
              </div>
            </div>
          </div>

          <div
            class="find__value_time"
            *ngIf="columnFilterTypes[data.fieldName]=='TIME' && benchmarksEnabled && !betweenOperators[data.operator]"
          >
            <div class="find__value_time_container">
              <div class="find__value_time-input" (mouseup)="timezoneClick('inputMask')">
                {{data.value != null ? data.value.timeValue : ''}}
              </div>
              <div class="find__value__timezone-input" (mouseup)="timezoneClick('autocomplete')">
                <span
                  >{{data.value != null ? data.value.timezoneValue != null ?
                  data.value.timezoneValue.label : '' : ''}}</span
                >
                <bfx-icon-button
                  class="find__value__timezone-button ui-button-icon-only"
                  size="xs"
                  iconClass="icon-ion_chevron_down"
                ></bfx-icon-button>
              </div>
            </div>
          </div>
          <div
            class="find__value_time_between_container"
            *ngIf="columnFilterTypes[data.fieldName]=='TIME' && benchmarksEnabled && betweenOperators[data.operator]"
          >
            <div class="find__value_time find__value__time_between_from">
              <div class="find__value_time-row-from" fxLayout="row" fxLayoutGap="0px">
                <div
                  class="find__value_time-input find__value_time-input-between-to"
                  (mouseup)="timezoneClick('inputmask', 'from')"
                >
                  {{data.from ? data.from.timeValue : ''}}
                </div>
                <div
                  class="find__value__timezone-input find__value__timezone-input-between-from"
                  (mouseup)="timezoneClick('autocomplete', 'from')"
                >
                  <span>
                    {{data.from != null ? data.from.timezoneValue != null ?
                    data.from.timezoneValue.label : '' : ''}}</span
                  >
                  <bfx-icon-button
                    size="xs"
                    iconClass="icon-ion_chevron_down time-from-marker"
                  ></bfx-icon-button>
                </div>
              </div>
            </div>

            <div class="find__value_time find__value__time_between_to">
              <div class="find__value_time-row-to" fxLayout="row" fxLayoutGap="0px">
                <div
                  class="find__value_time-input find__value_time-input-between-to"
                  (mouseup)="timezoneClick('inputmask', 'to')"
                >
                  {{data.to ? data.to.timeValue : ''}}
                </div>
                <div
                  class="find__value__timezone-input find__value__timezone-input-between-to"
                  (mouseup)="timezoneClick('autocomplete', 'to')"
                >
                  <span>
                    {{data.to != null ? data.to.timezoneValue != null ? data.to.timezoneValue.label
                    : '' : ''}}</span
                  >
                  <bfx-icon-button
                    size="xs"
                    iconClass="icon-ion_chevron_down time-to-marker"
                  ></bfx-icon-button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template
          let-editablecol
          let-editableIndex="rowIndex"
          let-data="rowData"
          pTemplate="editor"
        >
          <ng-container *ngIf="data.hasRowExpanded">
            <div
              class="find__value_container"
              *ngIf="(columnFilterTypes[data.fieldName]=='NUMBER' || columnFilterTypes[data.fieldName]=='INT' || columnFilterTypes[data.fieldName]=='PERCENTAGE') && !betweenOperators[data.operator]"
            >
              <bfx-amount-spinner
                #selAmt
                [(ngModel)]="data.value"
                [showValidationBar]="false"
                [tabindex]="0"
                size="sm"
                [proxyTab]="data.proxyTabValue || proxyOnTabValue(data, outerDt, outerRowIndex, dt, editableIndex, editablecol, selAmt)"
                [keyupAssignZero]="false"
                bfxmodelchangesubject
                (onModelChange)="handleModelChange($event, data)"
                (onFocusEditable)="focusEditableValue(selAmt, data)"
              ></bfx-amount-spinner>
            </div>

            <div
              class="find__value_container"
              *ngIf="(columnFilterTypes[data.fieldName]=='RATE') && !betweenOperators[data.operator]"
            >
              <bfx-rate-spinner
                #selRate
                *ngIf="(columnFilterTypes[data.fieldName]=='RATE') && !betweenOperators[data.operator]"
                size="sm"
                [(ngModel)]="data.value"
                [showValidationBar]="false"
                [tabindex]="0"
                [proxyTab]="data.proxyTabValue || proxyOnTabValue(data, outerDt, outerRowIndex, dt, editableIndex, editablecol, selRate)"
                [keyupAssignZero]="false"
                bfxmodelchangesubject
                (onModelChange)="handleModelChange($event, data)"
                [attr.title]="data.showTooltip.value && data.hasValue ? getText(data, 'RATE') : ''"
              ></bfx-rate-spinner>
            </div>

            <span
              class="bfx-percentage"
              *ngIf="columnFilterTypes[data.fieldName]=='PERCENTAGE' && !betweenOperators[data.operator]"
              >%</span
            >

            <p-slider
              *ngIf="columnFilterTypes[data.fieldName]=='BOOLEAN'"
              [ngModel]="parseSwitchValue(data.value)"
              (ngModelChange)="data.value=$event ===1 ? 'true':'false'"
              [min]="0"
              [max]="1"
              [step]="1"
              [ngClass]="{'bfx-switch-true' : data.value=='true', 'bfx-switch-false' : data.value=='false'}"
              [tabindex]="1"
            ></p-slider>

            <div
              [bfx-input]="bfxInput"
              class="find__input-container"
              *ngIf="columnFilterTypes[data.fieldName]=='STRING'"
            >
              <input
                #selInput
                class="find__input ui-cell-editing bfx-field-inputted-sm-subtle"
                type="search"
                [(ngModel)]="data.value"
                spellcheck="false"
                [tabindex]="1"
                (keyup)="updateActiveRowState(data)"
                (keydown.enter)="onEnterValue(dt)"
                (keydown.tab)="onTabValue($event, data, outerDt, outerRowIndex, dt, editableIndex, editablecol, selInput)"
                (onFocusEditable)="focusEditableInput(selInput, data)"
                title="{{data.value}}"
              />
            </div>

            <bfx-find-filter-selector
              #selObject
              *ngIf="objectColumns[data.fieldName] && columnFilterTypes[data.fieldName]!='TIMEZONE_CD'"
              panelStyleClass="bfx-multi-selector-dropdown bfx-blotter__filter-manager__selector bfx_find"
              [optionsLookupFn]="objectValuesLookupFn[data.fieldName]"
              [selectedOptions]="data.value == '' ? null : data.value"
              [options]="objectValues[data.fieldName]"
              [optionSingleSelection]="isSingleSelectColumn(data.fieldName)"
              [proxyTab]="data.proxyTabValue || proxyOnTabValue(data, outerDt, outerRowIndex, dt, editableIndex, editablecol, selObject)"
              (blur)="focusTriggered($event, selObject, false)"
              (focus)="focusTriggered($event, selObject, true)"
              (keyup)="displayDropDown($event)"
              (selectedOptions)="selectOption(data, $event)"
              (onFocusEditable)="focusEditableDropdown(selObject, data)"
              (onClose)="onDropdownClose(dt, data)"
            ></bfx-find-filter-selector>
            <div
              *ngIf="columnFilterTypes[data.fieldName]=='TIMEZONE_CD' && !betweenOperators[data.operator]"
            >
              <bfx-autoComplete
                #selTimeZoneCdObject
                size="sm"
                dropdownMenuClass="bfx_find_search_operator"
                (completeMethod)="searchTimezoneCd($event, data)"
                (onDropdownClick)="showTimezoneCdOptions($event, data)"
                (ngModelChange)="onTimezoneCdChanged($event, data)"
                (onFocusEditable)="focusEditableDropdown(selTimeZoneCdObject, data)"
                [(ngModel)]="data.input.value"
                [autoHighlight]="false"
                [autoHighlightIndex]="timezoneCdAutoHighlightIndexes"
                [delay]="10"
                [dropdown]="true"
                [forceSelection]="false"
                [maxlength]="30"
                [minLength]="0"
                [skipShowTargetInvisible]="true"
                [skipSorting]="true"
                [suggestions]="timezoneSuggestions"
                [tabindex]="0"
                appendTo="body"
                placeholder="{{getText(data)}}"
                dataKey="value"
                field="label"
                state="4"
                checkDirtyBlur="true"
              ></bfx-autoComplete>
            </div>

            <div
              class="find__value_container find__value_container_flex"
              *ngIf="columnFilterTypes[data.fieldName]=='DATE' && !betweenOperators[data.operator]"
            >
              <div fxFlex="1 1 100%" *ngIf="data.operator != null && !equalOperator[data.operator]">
                {{getText(data)}}
              </div>
              <bfx-autoComplete
                *ngIf="data.operator == null || equalOperator[data.operator]"
                fxFlex="1 1 100%"
                size="sm"
                #pCalAutocompleteVal
                dropdownMenuClass="bfx_find_calendar_days"
                (completeMethod)="searchDateComparitor($event, data)"
                (ngModelChange)="onDateComparitorChanged($event, data)"
                (onDropdownClick)="showDateComparitorOptions($event, data)"
                [(ngModel)]="data.input.value"
                [autoHighlight]="false"
                [autoHighlightIndex]="dateComparitorAutoHighlightIndexes.value"
                [delay]="10"
                [dropdown]="true"
                [forceSelection]="true"
                [clearUnmatchedInputOnBlur]="true"
                (onFocusEditable)="focusEditableDate(pCalAutocompleteVal, data, 'autoComplete')"
                [maxlength]="30"
                [minLength]="0"
                [skipShowTargetInvisible]="true"
                [skipSorting]="true"
                [suggestions]="dateComparitorSuggestions.value"
                [tabindex]="0"
                appendTo="body"
                placeholder="{{getText(data)}}"
                dataKey="value"
                field="label"
                state="4"
                [disabled]="!equalNotEqualOperators[data.operator]"
                checkDirtyBlur="true"
              ></bfx-autoComplete>
              <div class="find__buttons" fxFlex="0 0 auto">
                <!-- <bfx-icon-button
                  size="xs"
                  iconClass="icon-calendar_month"
                  (action)="pCalValue.showOverlay()"
                  ></bfx-icon-button> -->
                <p-calendar
                  panelStyleClass="bfx-calendar-sm"
                  #pCalValue
                  [patchDragAutoclose]="pCalValue"
                  [patchDatePickerOnOpen]="pCalValue"
                  [patchPCalendarIcon]="pCalValue"
                  icon="fa icon-calendar_month"
                  (onFocusEditable)="focusEditableDate(pCalValue, data, 'calendar')"
                  [appendTo]="calendarPanelHelper"
                  placeholder="{{getText(data)}}"
                  [ngModel]="data.calendar.value"
                  (ngModelChange)="onDateComparitorFromCalendar($event, data)"
                  [showIcon]="true"
                  [showOnFocus]="false"
                  showOtherMonths="true"
                  selectOtherMonths="true"
                  dateFormat="dd M yy"
                  [tabindex]="1"
                  (onClose)="onDropdownClose(dt, data)"
                  (onOpen)="onDatepickerOpen(dt, data)"
                >
                </p-calendar>
              </div>
            </div>

            <div
              class="find__value_between_container"
              *ngIf="(columnFilterTypes[data.fieldName]=='NUMBER' || columnFilterTypes[data.fieldName]=='INT' || columnFilterTypes[data.fieldName]=='PERCENTAGE') && betweenOperators[data.operator]"
            >
              <bfx-amount-spinner
                #selAmtFrom
                size="sm"
                [(ngModel)]="data.from"
                [showValidationBar]="false"
                [tabindex]="0"
                [keyupAssignZero]="false"
                bfxmodelchangesubject
                (onModelChange)="handleModelChange($event, data, 'from')"
              >
                <!-- no proxy tab -->
              </bfx-amount-spinner>

              <span
                class="bfx-percentage"
                *ngIf="columnFilterTypes[data.fieldName]=='PERCENTAGE'"
                style="margin-left: 4px"
                >%</span
              >

              <bfx-amount-spinner
                #selAmtTo
                size="sm"
                [(ngModel)]="data.to"
                [showValidationBar]="false"
                [tabindex]="0"
                [proxyTab]="data.proxyTabTo || proxyOnTabValue(data, outerDt, outerRowIndex, dt, editableIndex, editablecol, selAmtTo, 'to')"
                [keyupAssignZero]="false"
                bfxmodelchangesubject
                (onModelChange)="handleModelChange($event, data, 'to')"
              >
              </bfx-amount-spinner>

              <span
                class="bfx-percentage"
                *ngIf="columnFilterTypes[data.fieldName]=='PERCENTAGE'"
                style="margin-left: 4px"
                >%</span
              >
            </div>

            <div
              class="find__value_between_container"
              *ngIf="(columnFilterTypes[data.fieldName]=='RATE') && betweenOperators[data.operator]"
            >
              <bfx-rate-spinner
                #selRateFrom
                size="sm"
                [(ngModel)]="data.from"
                [showValidationBar]="false"
                [tabindex]="0"
                [keyupAssignZero]="false"
                bfxmodelchangesubject
                (onModelChange)="handleModelChange($event, data, 'from')"
                [attr.title]="data.showTooltip.from && data.hasValue ? getText(data, 'RATE', 'from') : ''"
              >
                <!-- no proxy tab -->
              </bfx-rate-spinner>

              <bfx-rate-spinner
                #selRateTo
                size="sm"
                [(ngModel)]="data.to"
                [showValidationBar]="false"
                [tabindex]="0"
                [proxyTab]="data.proxyTabTo || proxyOnTabValue(data, outerDt, outerRowIndex, dt, editableIndex, editablecol, selRateTo, 'to')"
                [keyupAssignZero]="false"
                bfxmodelchangesubject
                (onModelChange)="handleModelChange($event, data, 'to')"
                [attr.title]="data.showTooltip.to && data.hasValue ? getText(data, 'RATE', 'to') : ''"
              >
              </bfx-rate-spinner>
            </div>

            <div
              class="find__value_container find__value_container_flex find__value_between_container"
              *ngIf="columnFilterTypes[data.fieldName]=='DATE' && betweenOperators[data.operator]"
            >
              <input
                style="display: none"
                #selBetween
                (onFocusEditable)="focusEditableBetweenProxy(selBetween, data, selBetweenFrom, selBetweenTo)"
              />

              <div #selBetweenFrom class="find__value_between_from">
                <div>{{getText(data, columnFilterTypes[data.fieldName], 'from')}}</div>
                <div class="find__buttons">
                  <p-calendar
                    panelStyleClass="bfx-calendar-sm"
                    #pCalFrom
                    dropdownMenuClass="bfx_find_calendar_days"
                    icon="fa icon-calendar_month"
                    [patchDragAutoclose]="pCalFrom"
                    [patchDatePickerOnOpen]="pCalFrom"
                    [patchPCalendarIcon]="pCalFrom"
                    (onFocusEditable)="focusEditableDate(pCalFrom, data, 'calendar', 'from')"
                    [appendTo]="calendarPanelHelper"
                    placeholder="{{getText(data, columnFilterTypes[data.fieldName], 'from')}}"
                    [ngModel]="data.calendar.from"
                    (ngModelChange)="onDateComparitorFromCalendar($event, data, 'from')"
                    [maxDate]="data.calendar.to ? data.calendar.to : null"
                    [showIcon]="true"
                    [showOnFocus]="false"
                    showOtherMonths="true"
                    selectOtherMonths="true"
                    dateFormat="dd M yy"
                    [tabindex]="1"
                    (onClose)="onDropdownClose(dt, data)"
                    (onOpen)="onDatepickerOpen(dt, data, 'from')"
                  >
                  </p-calendar>
                </div>
              </div>

              <div #selBetweenTo class="find__value_between_to">
                <div>{{getText(data, columnFilterTypes[data.fieldName], 'to')}}</div>
                <div class="find__buttons">
                  <p-calendar
                    panelStyleClass="bfx-calendar-sm"
                    #pCalTo
                    [patchDragAutoclose]="pCalTo"
                    [patchDatePickerOnOpen]="pCalTo"
                    [patchPCalendarIcon]="pCalTo"
                    (onFocusEditable)="focusEditableDate(pCalTo, data, 'calendar', 'to')"
                    [appendTo]="calendarPanelHelper"
                    placeholder="{{getText(data, columnFilterTypes[data.fieldName], 'to')}}"
                    [ngModel]="data.calendar.to"
                    (ngModelChange)="onDateComparitorFromCalendar($event, data, 'to')"
                    [minDate]="data.calendar.from ? data.calendar.from : null"
                    [showIcon]="true"
                    [showOnFocus]="false"
                    showOtherMonths="true"
                    selectOtherMonths="true"
                    dateFormat="dd M yy"
                    [tabindex]="1"
                    (onClose)="onDropdownClose(dt, data)"
                    (onOpen)="onDatepickerOpen(dt, data, 'to')"
                  >
                  </p-calendar>
                </div>
              </div>
            </div>
            <div
              class="find__value_container"
              *ngIf="columnFilterTypes[data.fieldName]=='TIME' && benchmarksEnabled && !betweenOperators[data.operator]"
            >
              <input style="display: none" tabindex="-1" disabled="disabled" />
              <bfx-time-input
                #selTime
                fxLayout="row"
                class="find__value__time-input"
                [skipDefaults]="true"
                [userZone]="false"
                [fillTimeOnZone]="true"
                [ngModel]="data.input.value"
                [showValidation]="false"
                (ngModelChange)="onTimeInputChanged($event, data)"
                (onFocusEditable)="focusEditableTime(selTime, data)"
                [nativeDropdown]="false"
              >
              </bfx-time-input>
            </div>
            <div
              class="find__value_time_between_container"
              *ngIf="(columnFilterTypes[data.fieldName]=='TIME') && benchmarksEnabled && betweenOperators[data.operator]"
            >
              <input
                style="display: none"
                tabindex="-1"
                disabled="disabled"
                #selTimeBetween
                (onFocusEditable)="focusEditableBetweenProxy(selTimeBetween, data, selTimeBetweenFrom, selTimeBetweenTo)"
              />

              <div #selTimeBetweenFrom class="find__value_between_from">
                <bfx-time-input
                  #selTimeFrom
                  fxLayout="row"
                  class="find__value__time-input"
                  [skipDefaults]="true"
                  [fillTimeOnZone]="true"
                  [userZone]="false"
                  [ngModel]="data.input.from"
                  [showValidation]="false"
                  (ngModelChange)="onTimeInputChanged($event, data, 'from')"
                  (onFocusEditable)="focusEditableTime(selTimeFrom, data, 'from')"
                  [nativeDropdown]="false"
                >
                </bfx-time-input>
              </div>
              <div #selTimeBetweenTo class="find__value_between_to">
                <bfx-time-input
                  #selTimeTo
                  fxLayout="row"
                  class="find__value__time-input"
                  [skipDefaults]="true"
                  [userZone]="false"
                  [fillTimeOnZone]="true"
                  [ngModel]="data.input.to"
                  [showValidation]="false"
                  (ngModelChange)="onTimeInputChanged($event, data, 'to')"
                  (onFocusEditable)="focusEditableTime(selTimeTo, data, 'to')"
                  [nativeDropdown]="false"
                >
                </bfx-time-input>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </p-column>
    </p-dataTable>
  </ng-template>
  <!-- <p-column #expanderRef expander="true" styleClass="col-icon" [style]="{'width': '30px'}"></p-column> -->
</p-dataTable>
